import { DefaultOptionType } from "antd/es/select";
import { EPartType } from "@drone-parts.garphild.pro/interfaces";

export const mainOrderCategories: DefaultOptionType[] = [
  { label: "Drone", value: "drone" },
  { label: "Battery", value: "battery" },
  { label: "Equipment", value: "equipment" },
  { label: "Electronics", value: "electronics" },
  { label: "Medicine", value: "medicine" },
  { label: "Other", value: "other" },
  { label: "Volunteer", value: "volunteer" },
]

export const itemsCategories: Record<string, (DefaultOptionType & { value: string })[]> = {
  main: [
    { label: "Drone", value: "drone" },
    { label: "Battery", value: "battery" },
    { label: "Equipment", value: "equipment" },
    { label: "Medicine", value: "medicine" },
  ],
  drone: [
    { label: "Frame", value: EPartType.frame },
    { label: EPartType.frame7, value: EPartType.frame7 },
    { label: EPartType.frame7rs, value: EPartType.frame7rs },
    { label: EPartType.frame7small, value: EPartType.frame7small },
    { label: EPartType.frame7Big, value: EPartType.frame7Big },
    { label: EPartType.frame8, value: EPartType.frame8 },
    { label: EPartType.frame9, value: EPartType.frame9 },
    { label: EPartType.frame10, value: EPartType.frame10 },
    { label: EPartType.frame10more, value: EPartType.frame10more },
    { label: "Motor", value: EPartType.motors },
    { label: EPartType.motors25, value: EPartType.motors25 },
    { label: EPartType.motors28, value: EPartType.motors28 },
    { label: EPartType.motors2812, value: EPartType.motors2812 },
    { label: EPartType.motors31, value: EPartType.motors31 },
    { label: "FC Stack", value: EPartType.fcStack },
    { label: EPartType.fcStack45A, value: EPartType.fcStack45A },
    { label: EPartType.fcStack50A, value: EPartType.fcStack50A },
    { label: EPartType.fcStack55A, value: EPartType.fcStack55A },
    { label: EPartType.fcStack60A, value: EPartType.fcStack60A },
    { label: "Flight controller", value: EPartType.fcSingle },
    { label: "ESC", value: EPartType.esc },
    { label: EPartType.esc45A, value: EPartType.esc45A },
    { label: EPartType.esc50A, value: EPartType.esc50A },
    { label: EPartType.esc55A, value: EPartType.esc55A },
    { label: EPartType.esc60A, value: EPartType.esc60A },
    { label: "PDB", value: EPartType.pdb },
    { label: "Camera", value: EPartType.camera },
    { label: EPartType.cameraSimple, value: EPartType.cameraSimple },
    { label: EPartType.cameraEvening, value: EPartType.cameraEvening },
    { label: EPartType.cameraNightIR, value: EPartType.cameraNightIR },
    { label: EPartType.cameraThermal, value: EPartType.cameraThermal },
    { label: EPartType.cameraZoom, value: EPartType.cameraZoom },
    { label: EPartType.cameraSwitcher, value: EPartType.cameraSwitcher },
    { label: "Receiver", value: EPartType.receiver },
    { label: EPartType.receiverSimple, value: EPartType.receiverSimple },
    { label: EPartType.receiverDiversity, value: EPartType.receiverDiversity },
    { label: EPartType.receiverCrossfire, value: EPartType.receiverCrossfire },
    { label: EPartType.receiver24, value: EPartType.receiver24 },
    { label: "VTX", value: EPartType.vtx },
    { label: EPartType.vtxSmall, value: EPartType.vtxSmall },
    { label: EPartType.vtxMiddle, value: EPartType.vtxMiddle },
    { label: EPartType.vtxBig, value: EPartType.vtxBig },
    { label: "Antenna", value: EPartType.antenna },
    { label: "SMA Pigtail", value: EPartType.antennaConnector },
    { label: "Screws", value: EPartType.screws },
    { label: "Nuts", value: EPartType.nuts },
    { label: "Shock absorbers", value: EPartType.dampers },
    { label: "Propellers", value: EPartType.propellers },
    { label: EPartType.propellers7, value: EPartType.propellers7 },
    { label: EPartType.propellers8, value: EPartType.propellers8 },
    { label: EPartType.propellers9, value: EPartType.propellers9 },
    { label: EPartType.propellers10, value: EPartType.propellers10 },
    { label: "Battery", value: EPartType.battery },
    { label: "Battery Straps", value: EPartType.batteryStrap },
    { label: "Sponge", value: EPartType.sponges },
    { label: "Cable sleeve", value: EPartType.cableSleeve },
    { label: "Cables", value: EPartType.cable },
    { label: EPartType.cablePower, value: EPartType.cablePower },
    { label: "Amas XT-60h-m", value: EPartType.xt60ConnectorM },
    { label: "Condensator", value: EPartType.condensator },
    { label: EPartType.condensatorN, value: EPartType.condensatorN },
    { label: EPartType.condensatorB, value: EPartType.condensatorB },
    { label: "Mounts", value: EPartType.mounts },
    { label: "GPS", value: EPartType.gps },
    { label: "Buzzer", value: EPartType.buzzer },
    { label: "Led", value: EPartType.led },
    { label: "Nylon tie", value: EPartType.nylonTie },
  ],
  battery: [
    { label: "LiIon element", value: EPartType.accumulators },
    { label: "Nickel strip", value: EPartType.nickelStrip },
    { label: "AWG Cable", value: EPartType.cable },
    { label: "Balancing Cable", value: EPartType.balancingCable },
    { label: "Strong adgesive tape", value: EPartType.strongAdhesiveTape },
    { label: "Adgesive tape", value: EPartType.adhesiveTape },
    { label: "Capton tape", value: EPartType.captonTape },
    { label: "Carton", value: EPartType.carton },
    { label: "Battery Insulation Gasket", value: EPartType.cartonRings },
    { label: "Pvc tube", value: EPartType.heatShrink },
    { label: "Hot glue", value: EPartType.hotGlue },
    { label: "Amas XT-60h-f", value: EPartType.xt60ConnectorF },
  ],
  equipment: [
    { label: "Adapter", value: 'Adapter' },
    { label: "Soldering", value: 'Soldering' },
    { label: "Measurement", value: 'Measurement' },
    { label: "Screwdriver Bits", value: EPartType.screwdriverBits },
    { label: "Other", value: 'Other' },
  ],
  electronics: [
    { label: "RF chips", value: 'RF chips' },
    { label: "GPS", value: EPartType.gps },
    { label: "Microcontroller", value: 'Microcontroller' },
    { label: "LCD", value: 'LCD' },
    { label: "Other", value: 'Other' },
  ],
  medicine: [
    { label: "Other", value: 'Other' },
  ],
  volunteer: [
    { label: "Other", value: 'Other' },
  ],
  other: [
    { label: "Personal", value: 'Personal' },
    { label: "Parts for R&D", value: 'Parts for R&D' },
  ]
}
